<pf-section
        name="anliegen"
        title="{{ 'sendmail.prepare.step.concern' | i18next }}"
        subtitle="{{ 'sendmail.prepare.step.concern-info' | i18next }}"
>
    <div class="row ba-form-row" [ngClass]="{ 'ba-loading': showLoading }">
        <div class="col-12 col-sm-6">
            <pf-dropdown
                    [value]="anliegen?.id ?? ''"
                    name="anliegen"
                    (valueChange)="anliegenChanged.emit($event)"
                    label="{{ 'sendmail.prepare.step.concern' | i18next }}"
                    placeholder="-- {{ 'sendmail.prepare.step.placeholder' | i18next }} --"
                    [options]="dropdownAnliegenOptions"
            ></pf-dropdown>
        </div>


        <div class="col-12 col-sm-6">
            @if (subanliegenList.length > 1) {
                <pf-dropdown
                        [value]="subanliegen?.id ?? ''"
                        name="subanliegen"
                        (valueChange)="subanliegenChanged.emit($event)"
                        label="{{ 'sendmail.prepare.step.concern-type' | i18next }}"
                        placeholder="-- {{ 'sendmail.prepare.step.placeholder' | i18next }} --"
                        [options]="dropdownSubanliegenOptions"
                ></pf-dropdown>
            }
        </div>
    </div>
</pf-section>